import React, { useEffect, useState } from "react";
import axios from "axios";
import secureLocalStorage from "./storage";
import OtpInput from "react-otp-input";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import Manubar from "./Manubar";
import Footer from "./Footer";
import Security from "./Security";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  let Navigate = useNavigate();
  let [loginvalue, setloginvalue] = useState();
  let [pinvalue, setPinValue] = useState();
  let [numbermsg, setnumbermsg] = useState();
  let [emailmsg, setemailmsg] = useState();
  let [inputval, setinputval] = useState({
    full_name: "",
    mobile_no: "",
    email: "",
    pin: "",
  });

  // Forget PIN states
  const [showForgetPin, setShowForgetPin] = useState(false);
  const [forgetEmail, setForgetEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPin, setNewPin] = useState("");
  const [userId, setUserId] = useState("");
  const [showNewPin, setShowNewPin] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  let _id = secureLocalStorage.getItem("n_id");
  const [showPin, setShowPin] = useState(false);

  //inputvalue
  let inputvalue = (event) => {
    setinputval({ ...inputval, [event.target.name]: event.target.value });
  };

  // Signup form Handel
  let formHandel = (event) => {
    event.preventDefault();
    let mmobile = /^\d{10}$|^\d{3}[-\s]\d{3}[-\s]\d{4}$/;
    let eemail = /^[a-zA-Z0-9._%+-]+@gmail\.com$/i;
    if (eemail.test(inputval.email)) {
      setemailmsg("");
    } else if (!eemail.test(inputval.email)) {
      setemailmsg("Wrong-Email");
    }
    if (!mmobile.test(inputval.mobile_no)) {
      setnumbermsg("Wrong-Number");
    } else {
      setnumbermsg("");
      setemailmsg("");
      axios
        .post(`${process.env.REACT_APP_API}website/signup`, inputval)
        .then((res) => {
          console.log(res);
          if (res.data.result) {
            secureLocalStorage.setItem("n_id", res.data._id);
            secureLocalStorage.setItem("n_token", res.data.token);
            toast.success("Signup successfully");
            setinputval({
              full_name: "",
              mobile_no: "",
              email: "",
            });
          }
        })
        .catch((error) => {
          toast.success("All Redy Signup This Number");
        });
    }
  };

  // Login Form Handel
  let Loginform = (event) => {
    event.preventDefault();
    let mmobile = /^\d{10}$|^\d{3}[-\s]\d{3}[-\s]\d{4}$/;
    if (mmobile.test(loginvalue)) {
      let data = {
        mobile_no: loginvalue,
        pin: pinvalue,
      };
      setnumbermsg("");
      axios
        .post(`${process.env.REACT_APP_API}website/login`, data)
        .then((res) => {
          console.log(res);
          localStorage.setItem("localdata", JSON.stringify(res.data.data));
          if (res.data.result) {
            localStorage.setItem("ssstoken", res.data.data.token);
            secureLocalStorage.setItem("n_id", res.data.data._id);
            secureLocalStorage.setItem("n_token", res.data.data.token);
            secureLocalStorage.setItem("n_mobile_no", res.data.data.mobile_no);
            toast.success("Login successfully");
            setTimeout(() => {
              Navigate("/");
            }, 2000);
          }
        })
        .catch((res) => {
          toast.error("Invalid Mobile Number or Pin");
        });
    } else if (!mmobile.test(loginvalue)) {
      setnumbermsg("Wrong-Number");
    }
  };

  // Forget PIN - Send OTP
  const handleForgetPin = (event) => {
    event.preventDefault();
    let eemail = /^[a-zA-Z0-9._%+-]+@gmail\.com$/i;
    
    if (!eemail.test(forgetEmail)) {
      toast.error("Please enter a valid email address");
      return;
    }

    axios
      .post(`${process.env.REACT_APP_API}website/forget_pin`, {
        email: forgetEmail
      })
      .then((res) => {
        if (res.data.result) {
          setUserId(res.data.data.userId);
          setOtpSent(true);

          toast.success("OTP sent successfully to your email");
        }
      })
      .catch((error) => {
        toast.error("Failed to send OTP. Please try again.");
      });
  };

  // Verify OTP and Set New PIN
  const handleVerifyOtp = (event) => {
    event.preventDefault();
    
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP");
      return;
    }

    if (newPin.length !== 4) {
      toast.error("PIN must be 4 digits");
      return;
    }

    axios
      .post(`${process.env.REACT_APP_API}website/verify_otp`, {
        _id: userId,
        otp: otp,
        new_pin: newPin
      })
      .then((res) => {
        if (res.data.result) {
          toast.success("PIN reset successfully");
          setShowForgetPin(false);
          setForgetEmail("");
          setOtp("");
          setNewPin("");
          setOtpSent(false);
        }
      })
      .catch((error) => {
        toast.error("Invalid OTP or failed to reset PIN");
      });
  };

  return (
    <div>
      <ToastContainer position="top-center" />
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  login &amp; register
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      {/* Forget PIN Modal */}
      {showForgetPin && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reset PIN</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => {
                    setShowForgetPin(false);
                    setOtpSent(false);
                    setForgetEmail("");
                    setOtp("");
                    setNewPin("");
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {!otpSent ? (
                  <form onSubmit={handleForgetPin}>
                    <div className="mb-3">
                      <label className="form-label">Enter your email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={forgetEmail}
                        onChange={(e) => setForgetEmail(e.target.value)}
                        placeholder="Enter your registered email"
                        required
                      />
                    </div>
                    <div className="text-center">
                      <button type="submit" className="btn btn-primary">
                        Send OTP
                      </button>
                    </div>
                  </form>
                ) : (
                  <form onSubmit={handleVerifyOtp}>
                    <div className="mb-3">
                      <label className="form-label">Enter OTP</label>

                      <input
                        type="text"
                        className="form-control"
                        value={otp}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "");
                          if (val.length <= 4) {
                            setOtp(val);
                          }
                        }}
                        placeholder="Enter 4-digit OTP"
                        maxLength="4"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">New PIN</label>
                      <div style={{ position: "relative" }}>
                        <input
                          type={showNewPin ? "text" : "password"}
                          className="form-control"
                          value={newPin}
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "");
                            if (val.length <= 4) {
                              setNewPin(val);
                            }
                          }}
                          placeholder="Enter new 4-digit PIN"
                          maxLength="4"
                          required
                        />
                        <span
                          onClick={() => setShowNewPin(!showNewPin)}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#555",
                          }}
                        >
                          {showNewPin ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                    </div>
                    <div className="text-center">
                      <button type="submit" className="btn btn-primary">
                        Reset PIN
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="login-register-area section-mb">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12 mx-auto">
              <div className="login-register-wrapper">
                <div
                  className="login-register-tab-list nav nav-tabs"
                  id="nav-tab"
                  role="tablist"
                >
                  <a className="active" data-bs-toggle="tab" href="#lg1">
                    <h4>login</h4>
                  </a>
                  <a data-bs-toggle="tab" href="#lg2">
                    <h4>register</h4>
                  </a>
                </div>
                <div className="tab-content">
                  <div id="lg1" className="tab-pane show active">
                    <div
                      className="login-form-container"
                      style={{ backgroundColor: "#a3c098" }}
                    >
                      <div className=" login-register-form ">
                        <form action="#" method="post">
                          <label style={{ color: "red", fontSize: "10px" }}>
                            {numbermsg}
                          </label>
                          <input
                            type="number"
                            name="mobile_no"
                            onChange={(e) => setloginvalue(e.target.value)}
                            placeholder="Mobile-Number"
                          />
{/* pin enter */}
                          <div style={{ position: "relative", width: "100%" }}>
                            <input
                              type={showPin ? "text" : "password"}
                              name="pin"
                              placeholder="PIN"
                              maxLength="4"
                              value={pinvalue}
                              onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, "");
                                if (val.length <= 4) {
                                  setPinValue(val);
                                }
                              }}
                              style={{
                                width: "100%",
                                paddingRight: "35px",
                                padding: "8px",
                                fontSize: "16px",
                              }}
                            />

                            {/* Eye icon */}
                            <span
                              onClick={() => setShowPin(!showPin)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "30%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#555",
                              }}
                            >
                              {showPin ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>

                          <div className="button-box">
                            <div className="login-toggle-btn">
                              <a 
                                href="#!" 
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowForgetPin(true);
                                }}
                                style={{ 
                                  cursor: "pointer", 
                                  color: "#007bff",
                                  textDecoration: "underline",
                                  fontSize: "14px"
                                }}
                              >
                                Forgot PIN?
                              </a>
                            </div>
                            <div className="text-center">
                              <button
                                onClick={Loginform}
                                className="btn btn-dark"
                              >
                                Login
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div id="lg2" className="tab-pane">
                    <div
                      className="login-form-container"
                      style={{ backgroundColor: "#a3c098" }}
                    >
                      <div className="login-register-form">
                        <form action="#" method="post" onSubmit={formHandel}>
                          <input
                            required
                            type="text"
                            name="full_name"
                            value={inputval.full_name}
                            onChange={inputvalue}
                            placeholder="Full Name"
                          />
                          <label style={{ color: "red", fontSize: "10px" }}>
                            {emailmsg}
                          </label>
                          <input
                            required
                            name="email"
                            value={inputval.email}
                            onChange={inputvalue}
                            placeholder="Email"
                            type="email"
                          />
                          <label style={{ color: "red", fontSize: "10px" }}>
                            {numbermsg}
                          </label>
                          <input
                            required
                            name="mobile_no"
                            value={inputval.mobile_no}
                            maxLength={"10"}
                            onChange={inputvalue}
                            placeholder="Mobile-Number"
                            type="number"
                          />

                          <div style={{ position: "relative", width: "100%" }}>
                            <input
                              type={showPin ? "text" : "password"}
                              name="pin"
                              placeholder="PIN"
                              maxLength="4"
                              value={inputval.pin}
                              onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, "");
                                if (val.length <= 4) {
                                  inputvalue({
                                    target: { name: "pin", value: val },
                                  });
                                }
                              }}
                              style={{
                                width: "100%",
                                paddingRight: "35px",
                                padding: "8px",
                                fontSize: "16px",
                              }}
                            />

                            {/* Eye icon */}
                            <span
                              onClick={() => setShowPin(!showPin)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "30%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#555",
                              }}
                            >
                              {showPin ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>

                          <div className="button-box">
                            <button className="btn btn-success">
                              Register
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Security />
      <Footer />
    </div>
  );
};

export default Login;